import classNames from "classnames"
import { useState, useEffect } from "react"
import Block from "@/components/wrappers/block"
import BlockHeader from "@/common/partials/block-header/block-header"
import Person from "@/common/cards/person/person"
import PersonModal from "@/common/cards/person/modal"
import Button from "@/common/button/button"
import styles from "./persons.module.css"

export default function Persons({ block }) {
  const { attrs } = block
  const [post, setPost] = useState(null)
  const [modalOpen, setModalOpen] = useState(false)

  const toggleModal = (modalOpen, post = null) => {
    if (modalOpen && post === null) {
      return null
    }

    setModalOpen(modalOpen)
    setPost(post)
  }

  useEffect(() => {
    const handleKeyup = (event) => {
      if (event.keyCode === 27) {
        toggleModal(false)
      }
    }

    window.addEventListener("keyup", handleKeyup)

    return () => {
      window.removeEventListener("keyup", handleKeyup)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (attrs.persons.length === 0) {
    return null
  }

  return (
    <Block
      block={block}
      gap={attrs?.blockGap ?? "normal"}
      className={classNames(styles.wrapper)}>
      <BlockHeader heading={attrs.heading} text={attrs.text} />
      <ul className={classNames("cols-" + attrs.cols)}>
        {attrs.persons.map((person, index) => {
          return (
            <Person key={index} person={person} toggleModal={toggleModal} />
          )
        })}
      </ul>
      <PersonModal isOpen={modalOpen} post={post} toggleModal={toggleModal} />
      <div className="button-wrapper">
        {attrs?.link?.url && (
          <Button tagName="a" href={attrs?.link?.url} theme="lime">
            {attrs?.button}
          </Button>
        )}
      </div>
    </Block>
  )
}
